"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNeptune = exports.createUranus = exports.createSaturn = exports.createJupiter = exports.createMars = exports.createVenus = exports.createMercury = void 0;
var Jupiter_1 = __importDefault(require("./Jupiter"));
var Mars_1 = __importDefault(require("./Mars"));
var Mercury_1 = __importDefault(require("./Mercury"));
var Neptune_1 = __importDefault(require("./Neptune"));
var Saturn_1 = __importDefault(require("./Saturn"));
var Uranus_1 = __importDefault(require("./Uranus"));
var Venus_1 = __importDefault(require("./Venus"));
function createMercury(toi) {
    return new Mercury_1.default(toi);
}
exports.createMercury = createMercury;
function createVenus(toi) {
    return new Venus_1.default(toi);
}
exports.createVenus = createVenus;
function createMars(toi) {
    return new Mars_1.default(toi);
}
exports.createMars = createMars;
function createJupiter(toi) {
    return new Jupiter_1.default(toi);
}
exports.createJupiter = createJupiter;
function createSaturn(toi) {
    return new Saturn_1.default(toi);
}
exports.createSaturn = createSaturn;
function createUranus(toi) {
    return new Uranus_1.default(toi);
}
exports.createUranus = createUranus;
function createNeptune(toi) {
    return new Neptune_1.default(toi);
}
exports.createNeptune = createNeptune;
